/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import {
  Paper,
  Box,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import EditTugasBelumTerlaksana from "../DialogEdit/EditTugasBelumTerlaksana";
import DialogDelete from "../DialogEdit/DialogDelete";
import {
  sendTugasBelumTerlaksana,
  getTugasBelumTerlaksana,
  deleteTugasBelumTerlaksana,
} from "../../../../../../store/actions";

const useStyles = makeStyles((theme) => ({
  textField: {
    marginBottom: theme.spacing(3),
  },
  table: {
    minWidth: 500,
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#285D5F",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const validationSchema = yup.object().shape({
  name: yup.string().required("Data Wajib diisi"),
});

const TugasBelumSelesai = ({
  detailEmployee,
  sendTugasBelumTerlaksana,
  getTugasBelumTerlaksana,
  deleteTugasBelumTerlaksana,
  auth,
}) => {
  const classes = useStyles();
  const params = useParams();

  const [checkRole, setCheckRole] = useState(false);
  const [dialog, setDialog] = useState({ open: false, value: null });
  const [dialogDelete, setDialogDelete] = useState({
    open: false,
    value: null,
  });

  const { handleSubmit, register, errors } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = (data, e) => {
    if (auth.user.id === parseInt(params.userId)) {
      sendTugasBelumTerlaksana(data);
    } else {
      sendTugasBelumTerlaksana(data, params.id);
    }
    e.target.reset();
  };

  useEffect(() => {
    if (!detailEmployee.loadingInformasiPekerjaan) {
      setCheckRole(true);
    }
  }, [detailEmployee.loadingInformasiPekerjaan]);

  useEffect(() => {
    if (auth.user.role_name === "manager" && auth.user.id !== parseInt(params.userId)) {
      getTugasBelumTerlaksana(true, params.id);
    } else {
      getTugasBelumTerlaksana();
    }
  }, []);

  return (
    <>
      {checkRole ? (
        auth.user.id === detailEmployee.profile.user_id ||
        (auth.user.role_name === "manager" &&
          auth.user.company_id ===
            detailEmployee.informasiPekerjaan.company_id &&
          auth.user.sequence < detailEmployee.informasiPekerjaan.sequence) ? (
          <Paper style={{ marginBottom: 10 }} elevation={3}>
            <Box p={3}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <TextField
                  className={classes.textField}
                  fullWidth
                  variant="outlined"
                  label={`Nama Tugas Belum Terlaksana`}
                  inputRef={register}
                  name="name"
                  error={!!errors.name}
                  helperText={!!errors.name && errors.name.message}
                />

                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  type="submit"
                >
                  Simpan
                </Button>
              </form>
            </Box>
          </Paper>
        ) : null
      ) : null}

      <Paper>
        <Box p={3}>
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>No</StyledTableCell>
                  <StyledTableCell>
                    Nama Tugas Yang Belum Terlaksana
                  </StyledTableCell>
                  {checkRole ? (
                    auth.user.id === detailEmployee.profile.user_id ||
                    (auth.user.role_name === "manager" &&
                      auth.user.company_id ===
                        detailEmployee.informasiPekerjaan.company_id &&
                      auth.user.sequence <
                        detailEmployee.informasiPekerjaan.sequence) ? (
                      <StyledTableCell>Action</StyledTableCell>
                    ) : null
                  ) : null}
                </TableRow>
              </TableHead>
              <TableBody>
                {detailEmployee.tugasBelumTerlaksana.length === 0 && (
                  <StyledTableRow>
                    <StyledTableCell align="center" colSpan={3}>
                      Data Kosong
                    </StyledTableCell>
                  </StyledTableRow>
                )}
                {detailEmployee.tugasBelumTerlaksana.map((row, index) => (
                  <StyledTableRow key={row.id}>
                    <StyledTableCell>{index + 1}</StyledTableCell>
                    <StyledTableCell>{row.name}</StyledTableCell>
                    {checkRole ? (
                      auth.user.id === detailEmployee.profile.user_id ||
                      (auth.user.role_name === "manager" &&
                        auth.user.company_id ===
                          detailEmployee.informasiPekerjaan.company_id &&
                        auth.user.sequence <
                          detailEmployee.informasiPekerjaan.sequence) ? (
                        <StyledTableCell>
                          <Tooltip title="Edit">
                            <IconButton
                              color="primary"
                              aria-label="edit"
                              onClick={() =>
                                setDialog({ open: true, value: row })
                              }
                            >
                              <EditIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Hapus">
                            <IconButton
                              aria-label="delete"
                              onClick={() =>
                                setDialogDelete({ open: true, value: row })
                              }
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </StyledTableCell>
                      ) : null
                    ) : null}
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <EditTugasBelumTerlaksana
          dialog={dialog}
          onClose={() => setDialog({ open: false, value: null })}
        />
        <DialogDelete
          dialog={dialogDelete}
          onClose={() => setDialogDelete({ open: false, value: null })}
          action={deleteTugasBelumTerlaksana}
          manager={auth.user.id === parseInt(params.userId)}
        />
      </Paper>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    detailEmployee: state.detailEmployee,
    auth: state.auth,
  };
};

export default connect(mapStateToProps, {
  sendTugasBelumTerlaksana,
  getTugasBelumTerlaksana,
  deleteTugasBelumTerlaksana,
})(TugasBelumSelesai);
